import { checkPermission } from "../../../Helpers/CheckAccess";
import { CUSTOMER, GetCustomer } from "../../Customer/Utilities/Customer";

const illustrationTypeConstant = {
  LI: "Life Insurance",
  ABLTC: "Asset-Based Long Term Care",
  LTC: "Long-Term Care",
  WL: "Whole Life",
  GUL: "Guaranteed UL",
  IUL: "Index UL",
  SPWL: "Single Premium Whole Life",
  UL: "Universal Life",
  VULLabel: "Variable Universal Life",
  VUL: "Variable UL",
  DILabel: "Disability Insurance",
  DI: "Disability",
  TraditionalLTC: "Traditional LTC",
};

const getQuoteTypeOptions = () => {
  const restrictedCustomers = [CUSTOMER.ALL_STATE];
  const shouldHideFromOptions = restrictedCustomers.includes(GetCustomer());

  const quoteTypeOptions = [
    {
      value: illustrationTypeConstant.LI,
      label: illustrationTypeConstant.LI,
      isHide: shouldHideFromOptions,
    },
    {
      value: illustrationTypeConstant.ABLTC,
      label: illustrationTypeConstant.ABLTC,
      isHide: shouldHideFromOptions,
    },
    {
      value: illustrationTypeConstant.DI,
      label: illustrationTypeConstant.DI,
      isHide: !checkPermission("enableDisabilityCard"),
    },
    {
      value: illustrationTypeConstant.LTC,
      label: illustrationTypeConstant.LTC,
      isHide: !checkPermission("enableTraditionalLTCCard"),
    },
  ].filter((item) => !item.isHide);

  return quoteTypeOptions;
};

const coverageTypeOptions = [
  { value: illustrationTypeConstant.WL, label: illustrationTypeConstant.WL },
  { value: illustrationTypeConstant.GUL, label: illustrationTypeConstant.GUL },
  { value: illustrationTypeConstant.IUL, label: illustrationTypeConstant.IUL },
  { value: illustrationTypeConstant.UL, label: illustrationTypeConstant.UL },
  {
    value: illustrationTypeConstant.VUL,
    label: illustrationTypeConstant.VULLabel,
  },
  {
    value: illustrationTypeConstant.DI,
    label: illustrationTypeConstant.DILabel,
  },
  {
    value: illustrationTypeConstant.TraditionalLTC,
    label: illustrationTypeConstant.TraditionalLTC,
  },
];

const PremiumModeOptions = [
  { value: "Single Pay", label: "Single Pay" },
  { value: "5 Pay", label: "5 Pay" },
  { value: "10 Pay", label: "10 Pay" },
];

const PremiumModeRadioOptions = [
  { value: "M", label: "Monthly" },
  { value: "A", label: "Annual" },
];

const ObjectiveOptions = [
  { value: "Family Protection", label: "Family Protection" },
  { value: "Wealth Protection", label: "Wealth Protection" },
  { value: "Business Continuity", label: "Business Continuity" },
  { value: "Asset Preservation", label: "Asset Preservation" },
  { value: "Estate Equalization", label: "Estate Equalization" },
  { value: "Income Replacement", label: "Income Replacement" },
];

const ImportantOptions = [
  { value: "", label: "--Select One--", disabled: true },
  { value: "Very Important", label: "Very Important" },
  { value: "Somewhat Important", label: "Somewhat Important" },
  { value: "Not Important", label: "Not Important" },
];

const RiskToleranceOption = [
  { value: "", label: "--Select One--", disabled: true },
  { value: "Very Conservative", label: "Very Conservative" },
  { value: "Conservative", label: "Conservative" },
  { value: "Moderate", label: "Moderate" },
  { value: "Aggressive", label: "Aggressive" },
  { value: "Very Aggressive", label: "Very Aggressive" },
];

const YesNoOptions = (isUnknown = false) => {
  const yesNoOptions = [
    { value: "", label: "--Select One--", disabled: true },
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];
  if (isUnknown) {
    yesNoOptions.push({ value: "Unknown", label: "Unknown" });
  }

  return yesNoOptions;
};

const BenefitType = [
  { value: "", label: "--Select One--", disabled: true },
  { value: "Individual", label: "Individual" },
  { value: "Survivorship", label: "Survivorship" },
];

const PolicyOwnerOptions = [
  { value: "", label: "--Select One--", disabled: true },
  { value: "Insured", label: "Insured" },
  { value: "Spouse", label: "Spouse" },
  { value: "Business", label: "Business" },
  { value: "Other", label: "Other" },
];

const PremiumDurationOptions = [
  { value: "", label: "--Select One--", disabled: true },
  { value: "Single", label: "Single" },
  { value: "1 Year", label: "1 Year" },
  { value: "5 Years", label: "5 Years" },
  { value: "10 Years", label: "10 Years" },
  { value: "20 Years", label: "20 Years" },
  { value: "To Age 60", label: "To Age 60" },
  { value: "To Age 65", label: "To Age 65" },
  { value: "Lifetime", label: "Lifetime" },
  { value: "Unknown", label: "Unknown" },
];

const DIBenefitPeriod = [
  { value: "", label: "--Select One--", disabled: true },
  { value: "1 Year", label: "1 Year" },
  { value: "2 Years", label: "2 Years" },
  { value: "5 Years", label: "5 Years" },
  { value: "10 Years", label: "10 Years" },
  { value: "To Age 65", label: "To Age 65" },
  { value: "To Age 67", label: "To Age 67" },
  { value: "To Age 70", label: "To Age 70" },
  { value: "Other", label: "Other" },
];

const DIEliminationPeriod = [
  { value: "", label: "--Select One--", disabled: true },
  { value: "30 Days", label: "30 Days" },
  { value: "60 Days", label: "60 Days" },
  { value: "90 Days", label: "90 Days" },
  { value: "180 Days", label: "180 Days" },
  { value: "365 Days", label: "365 Days" },
];

const DIRiders = [
  { value: "Automatic Increase Benefit", label: "Automatic Increase Benefit" },
  { value: "Catastrophic Rider", label: "Catastrophic Rider" },
  { value: "Cost of Living Adjustment", label: "Cost of Living Adjustment" },
  { value: "Future Insurability Option", label: "Future Insurability Option" },
  { value: "Own Occupation", label: "Own Occupation" },
  { value: "Partial Disability", label: "Partial Disability" },
];

const DIPaidMonthlyBenefit = [
  { value: "", label: "--Select One--", disabled: false },
  { value: "Employer Paid", label: "Employer Paid" },
  { value: "Employee Paid", label: "Employee Paid" },
  { value: "Unknown", label: "Unknown" },
];

const InflationProtectionOptions = [
  { value: "", label: "--Select One--", disabled: false },
  { value: "0", label: "0" },
  { value: "3%", label: "3%" },
  { value: "5%", label: "5%" },
];

export {
  YesNoOptions,
  ObjectiveOptions,
  ImportantOptions,
  RiskToleranceOption,
  BenefitType,
  PolicyOwnerOptions,
  PremiumDurationOptions,
  illustrationTypeConstant,
  getQuoteTypeOptions,
  coverageTypeOptions,
  PremiumModeOptions,
  PremiumModeRadioOptions,
  DIBenefitPeriod,
  DIEliminationPeriod,
  DIRiders,
  DIPaidMonthlyBenefit,
  InflationProtectionOptions,
};



// WEBPACK FOOTER //
// ./src/components/Product/RequestIllustration/Helper/Constant.js